<template>
  <div id="app">
    <LoadingPage v-if="selectedPage == 'loading'" />

    <LandingPage
      @pageChange="handlePageChange"
      v-if="selectedPage === 'landing'"
    />

    <LoginPage
      v-if="selectedPage === 'login'"
      @pageChange="handlePageChange"
      @getSessionInfo="getInfoSession"
    />

    <RecoverPasswordPage
      v-if="selectedPage === 'recover'"
      @pageChange="handlePageChange"
      @pageBack="handlePageBack"
    />

    <RegisterPage
      v-if="selectedPage === 'register'"
      @pageChange="handlePageChange"
    />

    <WorkSpacePage
      v-if="selectedPage === 'workspace'"
      :userData="userData"
      :idFuncionario="userData.Id_funcionario"
      :nombreUsuario="userData.nombres"
      :nombreCompleto="userData.nombreCompleto"
      :nombreIniciales="userData.nombreIniciales"
      :correoUsuario="userData.correo"
      @pageChange="handlePageChange"
      @updateDatosSesion="getInfoSession"
    />
  </div>
</template>

<script>
import "./assets/fonts/fonts.css";
import LoadingPage from "./views/LoadingPage.vue";
import LandingPage from "./views/LandingPage.vue";
import LoginPage from "./views/LoginPage.vue";
import RegisterPage from "./views/RegisterPage.vue";
import WorkSpacePage from "./views/WorkSpacePage.vue";
import RecoverPasswordPage from "./views/RecoverPasswordPage.vue";
import MEC_Funcionarios_api from "./modules/MEC_Funcionarios_api";

export default {
  name: "App",

  components: {
    LoadingPage,
    LandingPage,
    LoginPage,
    RegisterPage,
    WorkSpacePage,
    RecoverPasswordPage,
  },

  data() {
    return {
      selectedPage: "loading",
      lastPage: "",
      userData: {
        Id_funcionario: null,
        apellidos: "",
        cod_pais: "",
        correo: "",
        fecha_creacion: "",
        fecha_ultima_mod: "",
        habilitado: null,
        id_perfil: null,
        id_tipo_identificacion: null,
        identificacion: "",
        institucion: "",
        localidad: "",
        nombres: "",
        profesion: "",
        telefono: "",
        usr_LDAP: "",
        usuario: "",
        nombreCompleto: "",
        nombreIniciales: "",
      },
    };
  },

  async mounted() {
    await this.getInfoSession();
  },

  methods: {
    async getInfoSession() {
      const urlParams = new URLSearchParams(window.location.search);
      const apiFuncionarios = new MEC_Funcionarios_api();

      await apiFuncionarios
        .getInfoSession()
        .then((result) => {
          if (result.datos) {
            this.userData = result.datos;
            this.userData.nombreCompleto = `${result.datos.nombres} ${result.datos.apellidos}`;
            this.getNombreIniciales();
            this.selectedPage = "workspace";
          } else if (
            urlParams.get("redirect") &&
            urlParams.get("redirect") == "login"
          ) {
            this.selectedPage = "login";
          } else if (
            urlParams.get("redirect") &&
            urlParams.get("redirect") == "registro"
          ) {
            this.selectedPage = "register";
          } else {
            this.selectedPage = "landing";
          }
        })
        .catch((err) => {
          this.selectedPage = "landing";
          console.log(err);
        });
    },

    getNombreIniciales() {
      let arrayNombre = [];
      let nameInitials = "";

      arrayNombre = this.userData.nombres.split(" ");

      if (arrayNombre.length > 2) {
        arrayNombre = arrayNombre.slice(0, 2);
      }

      arrayNombre.forEach((e) => {
        nameInitials = nameInitials.concat(`${e.slice(0, 1)}`);
      });

      this.userData.nombreIniciales = nameInitials;
    },

    handlePageBack(pageInfo) {
      this.selectedPage = this.lastPage;
      this.lastPage = pageInfo.lastPage;
    },

    async handlePageChange(pageInfo) {
      if (pageInfo.lastPage == "login") {
        await this.getInfoSession();
      }

      this.selectedPage = pageInfo.page;
      this.lastPage = pageInfo.lastPage;
    },
  },
};
</script>

<style>
:root {
  --main-font: "Poppins", sans-serif;
  --special-font: "Blanka Regular", sans-serif;
  --bg-color: #121212;
  --grad-color-2: linear-gradient(90deg, #00f6bb 0%, #1d8fce 100%);
  --grad-color-azul: linear-gradient(90deg, #007cf0 0%, #00dfd8 100%);
  --grad-color-3: linear-gradient(90deg, #8c49fa 0%, #000aff 100%);
  --accent-color: #0035ef;
  --white: #ffffff;
  --black: #000000;
  --input-bg: #070707;
  --input-border: #4d4d4d;
  --hover-white: #a0a0a0;
  --blue-shade-light: #00bcd4;
  --blue-shade-regular: #0097a7;
  --blue-shade-dark: #006064;
  --hover-blue-shade-light: #0395a8;
  --hover-blue-shade-regular: #006975;
  --hover-blue-shade-dark: #004547;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  height: 100%;
}

th {
  text-align: center;
}

#app {
  font-family: var(--main-font);
  height: 100%;
}

.txt-bold {
  font-weight: 700;
}

.txt-accent {
  color: var(--accent-color);
}

.txt-grad-azul {
  background: var(--grad-color-azul);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  user-select: none;
}

.txt-grad-color-2 {
  background: var(--grad-color-2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  user-select: none;
}

.txt-grad-color-3 {
  background: var(--grad-color-3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  user-select: none;
}

::-ms-reveal {
  display: none;
}

::-ms-expand {
  display: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.logo {
  background-image: url(./assets/img/logo.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

/* Spinner */
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 0;
  border: 4px solid var(--white);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--white) transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
